import { useTranslation } from 'react-i18next';
import SEOHead from '@/components/SEOHead';
import Footer from '@/components/Footer';
import PricingTeaser from '@/components/home/PricingTeaser';
import MarketingHeader from '@/components/layouts/MarketingHeader';
import DctwOffer from '@/components/home/DctwOffer';

export default function PricingPage() {
  const { t } = useTranslation('pricing');

  return (
    <div className="min-h-screen bg-background font-outer">
      <SEOHead
        title={t('page.seoTitle')}
        description={t('page.seoDescription')}
        keywords={[
          'Memara pricing',
          'AI memory pricing',
          'free tier',
          'starter plan',
          'pro plan',
          'API limits',
        ]}
      />
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <MarketingHeader />
      <main id="main-content" className="container mx-auto max-w-6xl px-4 py-12 md:py-16">
        <div className="mx-auto mb-10 max-w-2xl text-center">
          <h1 className="mb-3 text-3xl font-bold tracking-tight text-foreground md:text-4xl">
            {t('page.title')}
          </h1>
          <p className="text-muted-foreground md:text-lg">{t('page.subtitle')}</p>
          <p className="mt-3 text-sm text-muted-foreground">{t('page.promoNote')}</p>
        </div>
        <div className="mb-10">
          <DctwOffer variant="section" />
        </div>
        <PricingTeaser enableAnimations showFullPricingLink={false} showSectionHeader={false} />
      </main>
      <Footer />
    </div>
  );
}
